<mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block" [class.component-dark-theme]="isToggled">
  <mat-card-header>
    <mat-card-title>
      <h5 class="mb-0">
        Ocjena prijave
      </h5>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="reviewForm" (ngSubmit)="submitReview()">
      @for (field of [
        { label: '1. Provedba programa/projekta/manifestacije će dovesti do zadovoljenja ciljeva iz strateških i razvojnih dokumenata odnosno natječaja', control: 'strategicGoalAchievementScore' },
        { label: '2. Prijavitelj je jasno razradio aktivnosti programa/projekta/manifestacije, aktivnosti su u skladu s ciljevima i očekivanim rezultatima, jasne, opravdane i provedive', control: 'activityClarityAndFeasibilityScore' },
        { label: '3. Aktivnosti su usmjerene na zadovoljenje potreba, u većoj mjeri građana općine Donji Andrijevci', control: 'localNeedsAlignmentScore' },
        { label: '4. Aktivnosti doprinose razvoju kulturnog/sportskog/društvenog života stanovnika općine Donji Andrijevci', control: 'communityLifeEnhancementScore' },
        { label: '5. Jasno su definirani i strateški odabrani sudionici (krajnji korisnici, ciljne skupine)', control: 'participantDefinitionScore' },
        { label: '6. Podnositelj (i partneri, ako je primjenjivo) imaju dovoljno iskustva u upravljanju programima i projektima/organizaciji manifestacija, dovoljnu tehničku stručnost i upraviteljsku sposobnost', control: 'managementAndExpertiseScore' },
        { label: '7. Troškovi u financijskom planu programa/projekta/manifestacije realno su iskazani', control: 'costRealismScore' },
        { label: '8. Stavke proračuna povezane su s prijavljenim aktivnostima', control: 'budgetItemLinkageScore' },
        { label: '9. Šira zajednica/volonteri će biti uključeni u provedbu aktivnosti', control: 'communityInvolvementScore' },
        { label: '10. U prijavi je jasno prikazan način obavještavanja javnosti o programu/projektu/manifestaciji, osigurana je promocija aktivnosti i Općine te medijska pokrivenost', control: 'publicCommunicationAndPromotionScore' }
        ]; track field) {
        <div >
          <mat-form-field class="mb-25">
            <mat-label>{{ field.label }}</mat-label>
            <input matInput type="number" [formControlName]="field.control" min="1" max="5" >
          </mat-form-field>
          @if (reviewForm.get(field.control)?.invalid && reviewForm.get(field.control)?.touched) {
            <div class="error text-danger">
              Molimo unesite ocjenu između 1 i 5.
            </div>
          }
        </div>
      }

      <mat-form-field class="mb-25">
        <mat-label>Opisna ocjena projekta/programa</mat-label>
        <textarea matInput formControlName="comments" ></textarea>
      </mat-form-field>
      @if (reviewForm.get('comments')?.invalid && reviewForm.get('comments')?.touched) {
        <div class="error text-danger">
          Opisna ocjena projekta/programa je obavezna.
        </div>
      }

      <button mat-raised-button color="primary" type="submit" [disabled]="reviewForm.invalid">
        Podnesite ocjenu
      </button>
    </form>
  </mat-card-content>
</mat-card>

